import { render, staticRenderFns } from "./creatStep2.vue?vue&type=template&id=986f9cee&scoped=true&"
import script from "./creatStep2.vue?vue&type=script&lang=js&"
export * from "./creatStep2.vue?vue&type=script&lang=js&"
import style0 from "./creatStep2.vue?vue&type=style&index=0&id=986f9cee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986f9cee",
  null
  
)

export default component.exports